import React, {useState, useRef} from 'react';
import {connect} from 'react-redux';
import TextArea from 'app/Components/Shared/TextArea/TextArea';
import TextInput from 'app/Components/Shared/TextInput/TextInput';
import MultipleFilesInput from 'app/Components/Shared/MultipleFileInput/MultipleFilesInput';
import BtnNextStep from '../BtnNextStep';
import {BusinessWorkOrderSystemStep, BusinessWorkOrderSystemPopup, fileExtensions} from '../Constant/Constant';
import {setSelectedWorkOrderRow, setFiles, setCurrentPopUp, getWorkOrderData} from '../BusinessWorkOrderSystemSlice';
import {isNullOrEmpty} from 'app/utilities/StringHelpers/StringHelpers';

const ReopenWorkOrder = (props) => {
  const textAreaRef = useRef(null);
  const titleRef = useRef(null);
  const [fileError, setFileError] = useState(null);
  const [isSubmit, setIsSubmit] = useState(false);

  const openPopup = async () => {
    const currentPopupData = props.dashboardData.find((row) => row.fuId === props.currentRow.fuId);
    if (currentPopupData.fuId) {
      if (isNullOrEmpty(currentPopupData.fuDetails)) {
        await props.getWorkOrderData({fu_number: currentPopupData.fuId, fu_ban: currentPopupData.fuBan});
      } else {
        const popupData = {
          currentPopupData: currentPopupData,
          currentPopUp: BusinessWorkOrderSystemPopup.WorkOrderData,
        };
        props.setCurrentPopUp(popupData);
      }
    }
  };

  const handleSubmit = () => {
    setIsSubmit(true);
    if (!fileError) {
      return BusinessWorkOrderSystemStep.WorkOrderConfirmation;
    }
    return;
  };
  return (
    <div className='reopen-work-order'>
      <div className='title'>פניה חוזרת</div>
      <div className='link-text cursor-pointer' onClick={() => openPopup()}>
        {' '}
        לפניה המקורית מספר {props.currentRow.fuId}
      </div>
      <div className='param'>
        <span className='param-label'> כותרת הפניה</span>
        <TextInput
          ref={titleRef}
          placeholder='חוזר:'
          onChange={(e) => {
            props.setSelectedWorkOrderRow({...props.currentRow, title: e.target.value});
          }}
          value={props.currentRow.title}
        />
      </div>
      <div className='param'>
        <span className='param-label'> תיאור הפניה</span>
        <TextArea
          placeholder='פרטים נוספים (לא חובה)'
          value={props.currentRow.textAreaValue}
          onChange={(e) => props.setSelectedWorkOrderRow({...props.currentRow, textAreaValue: e.target.value})}
          ref={textAreaRef}
          maxLength={601}
        />
      </div>
      <MultipleFilesInput
        files={props.businessWorkOrderSystem.files}
        setFiles={(files) => props.setFiles(files)}
        placeholder='צירוף קבצים לפניה'
        fileExtensions={fileExtensions}
        setFileError={setFileError}
      />
      <BtnNextStep text='שלח' onClick={handleSubmit} error={isSubmit && fileError} errorText={'אנא ודא כי כל הפרטים שמילאת תקינים'} />
    </div>
  );
};

const mapStateToProps = (state) => ({
  businessWorkOrderSystem: state.businessWorkOrderSystem,
  currentRow: state.businessWorkOrderSystem.selectedWorkOrderRow,
  dashboardData: state.businessWorkOrderSystem.dashboardData,
});

const mapDispatchToProps = {
  setSelectedWorkOrderRow,
  setFiles,
  setCurrentPopUp,
  getWorkOrderData,
};

export default connect(mapStateToProps, mapDispatchToProps)(ReopenWorkOrder);
